import { render, staticRenderFns } from "./XinguanOrderModal.vue?vue&type=template&id=deb58e5a&"
import script from "./XinguanOrderModal.vue?vue&type=script&lang=js&"
export * from "./XinguanOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports